<script lang="ts">
import type { ExternalLink, InternalLink } from '../../../../types/link';
import { getItemLinkRefUrl } from '../../../../utils/itemLinkRef';
import Button1XP from '../../../Button1XP/Button1XP.vue';
import type { NodeBase } from '../Nodes.vue';

export type NodeLink = NodeBase & {
  formData: ExternalLink | InternalLink;
};
</script>

<script setup lang="ts">
const { formData } = defineProps<NodeLink>();

const { lt_link_nofollow, lt_link_text, lt_link_target, lt_link_variant } = formData;

const url = getItemLinkRefUrl(formData);
const target = lt_link_target?.includes('blank') ? 'blank' : undefined;
</script>
<template>
  <Button1XP
    :no-follow="lt_link_nofollow"
    size="s"
    :target="target"
    :text="lt_link_text"
    :url="url"
    :variant="lt_link_variant === 'none' ? 'linkStatic' : lt_link_variant"
  />
</template>
